/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import { ChangeEvent, useMemo, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {
  Card,
} from '../../../components/Lists';
import InputSearch from '../../../components/InputSearch';
import { DataByEmployeeType } from '../types';
import floatToCurrency from '../../../utils/floatToCurrency';
import OpacityAnimation from '../../../components/OpacityAnimation';

interface WorkplaceListInterface {
  list: DataByEmployeeType[];
}

export default function WorkplaceList({
  list,
}: WorkplaceListInterface) {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredLts = useMemo(() => list?.filter((lt) => (
    lt.indicatedsLts.name.toLowerCase().includes(searchTerm.toLowerCase())
  )), [list, searchTerm]);

  function handleChangeSearchTerm(event: ChangeEvent<HTMLInputElement>) {
    setSearchTerm(event.target.value);
  }

  return (
    <>
      <InputSearch
        searchTerm={searchTerm}
        handleChangeSearchTerm={handleChangeSearchTerm}
        placeholder="Pesquisar local de trabalho indicado por nome"
      />
      <Container style={{ marginTop: 24 }}>
        <Row xs={1} md={1} lg={2}>
          {filteredLts?.map((ltI) => (
            <Col key={ltI.indicatedsLts.id}>
              <OpacityAnimation delay={0.1}>
                <Card>
                  <div className="info">
                    <div className="card-title">
                      <strong>{ltI.indicatedsLts.name}</strong>
                      <small>{floatToCurrency(ltI.indicatedsLts.vt)}</small>
                    </div>
                    <span>
                      VT Atual:
                      {' '}
                      {floatToCurrency(ltI.employee.vt)}
                    </span>
                    <span>
                      Economia de
                      {' '}
                      {floatToCurrency(ltI.employee.vt - ltI.indicatedsLts.vt)}
                    </span>
                  </div>
                </Card>
              </OpacityAnimation>
            </Col>
          ))}
        </Row>
      </Container>
    </>
  );
}
